// apps/prompts/src/components/PromptsLayout.tsx
import { FeedbackSource } from '@neuroforge/shared'
import {
  FeedbackWidget,
  useAuthStore,
  UserMenu,
  redirectToHubLogin,
} from '@neuroforge/shared/client'
import { AppShell, Button, ThemeToggle } from '@neuroforge/ui'
import { useState } from 'react'
import { Outlet, useLocation } from 'react-router'

import KeyboardShortcutsHelp from './KeyboardShortcutsHelp'
import NotificationBell from './NotificationBell'
import OnboardingOverlay from './OnboardingOverlay'
import PromptsSidebar from './PromptsSidebar'

import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'

export default function PromptsLayout() {
  const { isAuthenticated } = useAuthStore()
  const [showShortcuts, setShowShortcuts] = useState(false)
  const { pathname } = useLocation()

  // ─── Batch N: Global keyboard shortcuts ───
  useKeyboardShortcuts([
    {
      key: 'k',
      ctrl: true,
      handler: () => {
        const searchEl = document.querySelector<HTMLInputElement>(
          '[data-onboarding="search"] input',
        )
        searchEl?.focus()
      },
      description: 'Ouvrir la recherche',
    },
    {
      key: '?',
      handler: () => setShowShortcuts(true),
      description: 'Afficher les raccourcis',
    },
    {
      key: 'Escape',
      handler: () => setShowShortcuts(false),
      allowInInput: true,
      description: 'Fermer modale / panel',
    },
  ])

  return (
    <AppShell
      ambientVariant="prompts"
      routeKey={pathname}
      sidebar={<PromptsSidebar />}
      headerActions={
        <>
          {/* AppSwitcher déplacé en haut de PromptsSidebar */}
          <ThemeToggle className="h-10 rounded-2xl px-4 text-sm font-semibold transition" />
          {isAuthenticated && <NotificationBell />}
          {isAuthenticated ? (
            <UserMenu />
          ) : (
            <Button
              variant="secondary"
              size="sm"
              onClick={() => redirectToHubLogin()}
              className="glass"
            >
              Se connecter
            </Button>
          )}
        </>
      }
      overlays={
        <>
          <FeedbackWidget source={FeedbackSource.PROMPTS} />
          <OnboardingOverlay />
          <KeyboardShortcutsHelp isOpen={showShortcuts} onClose={() => setShowShortcuts(false)} />
        </>
      }
    >
      <Outlet />
    </AppShell>
  )
}
